module.exports = __webpack_public_path__ + "static/light-13b7931a5bc9eaab754b1c5b83d8012c.svg";